"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Navigation;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _semanticUiReact = require("semantic-ui-react");

var _campaignCreator = require("../../actions/campaignCreator");

var _useFeatureAccessHook = require("../../helpers/useFeatureAccessHook");

var _index = require("../../../index");

var _campaignCreatorNavHelpers = require("../../helpers/campaignCreatorNavHelpers");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import WorkflowStateFilter from '../../containers/WorkflowStateFilter';
// import { usePageElement } from '../../helpers/campaignCreatorContentHook';
function Navigation(props) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var navigationPermission = (0, _reactRedux.useSelector)(function (state) {
    return state.options.permissions.workflowPermission;
  });
  var campaignCreatorAccess = (0, _useFeatureAccessHook.useFeatureAccess)(navigationPermission); // const wayFindingLabel1 = usePageElement(
  //   'firstLandingPage',
  //   'wayfindingLabel'
  // );
  // const wayFindingLabel2 = usePageElement(
  //   'secondLandingPage',
  //   'wayfindingLabel'
  // );
  // const wayFindingLabel3 = usePageElement(
  //   'thirdLandingPage',
  //   'wayfindingLabel'
  // );

  (0, _react.useEffect)(function () {
    dispatch((0, _index.featureAccess)());
    dispatch((0, _campaignCreator.loadOptions)());
  }, [dispatch]);

  if (!campaignCreatorAccess) {
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Message, {
      content: "You do not have permission to view this content",
      error: true
    });
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "full-width campaign-creator-nav__container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "campaign-creator-nav__grid-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "campaign-creator-nav--wrapper"
  }, (0, _campaignCreatorNavHelpers.showBackButton)(window.location.pathname) ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    className: "campaign-creator-nav--button",
    as: _reactRouterDom.Link,
    to: (0, _campaignCreatorNavHelpers.backButtonLink)(window.location.pathname)
  }, "Back") : /*#__PURE__*/_react["default"].createElement("span", {
    className: "campaign-creator-nav__button-placeholder"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "campaign-creator-nav"
  }, props.children), (0, _campaignCreatorNavHelpers.showNextButton)(window.location.pathname) ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    className: "campaign-creator-nav--button",
    as: _reactRouterDom.Link,
    to: (0, _campaignCreatorNavHelpers.nextButtonLink)(window.location.pathname)
  }, "Next") : /*#__PURE__*/_react["default"].createElement("span", {
    className: "campaign-creator-nav__button-placeholder"
  }))));
}